/**
 * NavigationAgent2D registration: the parser, which reuses the Node parse.
 * linterParser.ts holds the property validators.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNode } from '../../node/parser';
const navigationAgent2DRegistration = {
    typeName: 'NavigationAgent2D',
    parser: parseNode,
};
nodeRegistry.register(navigationAgent2DRegistration);
//# sourceMappingURL=index.js.map